/* External */
import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../../../hocs/withInteractiveFocusable.hoc';

function TrackItem({
  className,
  focused,
  children,
  isSelected,
  shouldStealFocus,
  setFocus,
  onMouseDown,
  onMouseEnter,
}) {
  useEffect(() => {
    if (shouldStealFocus) setFocus();
  }, [setFocus, shouldStealFocus]);

  return (
    <InteractiveElement
      tag="li"
      className={
        `dtv-html5-c-tracks-controls__track-content-item ${
          isSelected ? 'dtv-html5-c-tracks-controls__track-content-item--selected' : ''
        } ${
          focused ? 'dtv-html5-c-tracks-controls__track-content-item--focused' : ''
        } ${className}`
      }
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      role="menuitem"
    >
      {isSelected && <Icon className="dtv-html5-c-tracks-controls__track-item-icon" name="check" />}
      <span>
        {children}
      </span>
    </InteractiveElement>
  );
}

TrackItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  focused: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool,
  shouldStealFocus: PropTypes.bool,
  setFocus: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

TrackItem.defaultProps = {
  className: '',
  isSelected: false,
  shouldStealFocus: false,
  onMouseDown: undefined,
  onMouseEnter: undefined,
};

export default memo(withInteractiveFocusable()(memo(TrackItem)));
